//component entry file
import Ranking from "./components/rank/Ranking.vue";

export default Ranking;